import { createCRUDHook } from './createCRUDHook';
import { CustomerCommunicationDto } from 'utils/models';
import { CRM_CUSTOMER_COMMUNICATION } from './apiEndPoints';

const { Context, useManager, useConsumer } =
  createCRUDHook<CustomerCommunicationDto>({
    entityName: 'CustomerCommunication',
    endpoint: CRM_CUSTOMER_COMMUNICATION,
  });

export const CustomerCommunicationContext = Context;
export const useCustomerCommunicationManager = useManager;
export const useCustomerCommunication = useConsumer;
